import styles from '../globals/pages.module.scss'

import { useEffect, useState } from 'react'
import axios from 'axios'
import { useParams, useSearchParams } from 'react-router-dom'

import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { browserName, osName, deviceDetect, getUA } from 'react-device-detect'

import { Wrapper, SignaturePad } from '../components/reusable'
import CfaBanner from '../components/cfaBanner'
import SingleSignatureContainer from '../components/singleSigContainer'
import { apiErrors } from '../helpers/apiErrors'
import PocView from '../components/pocView'
import { useUpdateClaimData } from '../claimProvider'
import LCCfaBanner from '../components/LCCfaBanner'
import Modal from '../components/reusable/modal'
import Previewer from '../components/reusable/previewer'

export default function CfaLC() {
    const [cfaData, setCfaData] = useState([])
    const [retrievedCfa, setRetrievedCfa] = useState(false)
    const [currentClaim, setCurrentClaim]: any = useState({})
    const [cfaModalState, setCfaModalState] = useState(false)
    const [loaModalState, setLoaModalState] = useState(false)
    const [aofModalState, setAofModalState] = useState(false)
    const { token } = useParams()
    const updateClaim = useUpdateClaimData()

    const [searchParams] = useSearchParams()
    const chase_id = searchParams.get('chase_id')
    const agent = searchParams.get('agent')
    useEffect(() => {
        if (!retrievedCfa) {
            Loading.standard('Loading...')
            console.log('chase_id=', chase_id)
            axios
                .post(`${process.env.REACT_APP_API_TOKEN_URL}/lc-cfa`, { token })
                .then((response) => {
                    const responseData = response.data
                    if (responseData == 'CFA Complete') {
                        Report.success('Document Signed', 'Your Document has already been signed.', 'Okay', () => {
                            window.location.href = 'https://sentinellegal.co.uk'
                        })
                    }

                    const signatureData = responseData.sigData
                    console.log(signatureData)

                    if (!signatureData) throw new Error(responseData)
                    localStorage.setItem('name', `${signatureData.first_name} ${signatureData.last_name}`)

                    setCfaData(signatureData)
                    setCurrentClaim(signatureData)
                    setRetrievedCfa(true)
                    updateClaim(signatureData)

                    Loading.remove()
                })
                .catch((e) => {
                    console.error('error:', e)
                    const serverError = e.response.data
                    Loading.remove()
                    apiErrors(serverError)
                })
        }
    }, [])

    const completeCfa = (obj: any) => {
        Report.success(
            'Contingency Fee Agreement Complete',
            'Thank you for signing your document. We will update you on your cases in due course.',
            'Okay',
            () => {
                window.location.href = 'https://sentinellegal.co.uk'
            }
        )

        return
    }

    const handleCfaModal = () => {
        setCfaModalState(!cfaModalState)
    }

    const handleLoaModal = () => {
        setLoaModalState(!loaModalState)
    }

    const handleAofModal = () => {
        setAofModalState(!aofModalState)
    }

    return (
        <div className={`${styles.pageContent} ${styles.pocContent}`}>
            <LCCfaBanner />
            <Wrapper>
                <div>
                    <form>
                        <div className={styles.centeredContainer}>
                            <h2 className={styles.headerTitle}>
                                You could get back thousands of pounds from your mis-sold car finance deal!
                            </h2>
                            <span className={styles.headerDivider}></span>
                            <p className={styles.centeredText}>
                                After looking at the information you gave us, we think you might have a chance to make a
                                claim for mis-sold car finance.
                            </p>
                            <p className={styles.centeredText}>
                                Sentinel Legal will check this for free. If we find you can make a claim, we'll work to
                                get your money back—and you won't pay us anything unless we win!
                            </p>
                            <hr />
                        </div>
                    </form>
                </div>
                <PocView>
                    {retrievedCfa ? (
                        <>
                            <div className={styles.narrowContainer}>
                                <SignaturePad
                                    additionalAction={() => completeCfa({})}
                                    extraPayload={{
                                        type: 'lc-cfa-signature',
                                        noDuplicateClaimConsent: false,
                                        metadata: {
                                            browser: browserName,
                                            device: osName,
                                            routedBy: 'CF',
                                            chase_id,
                                            agent,
                                        },
                                    }}
                                    additionalDisclosure={{
                                        content: (() => {
                                            const pStyle = { fontSize: '12px', margin: '0 0 0.8em' } as const
                                            const liStyle = { fontSize: '12px' } as const
                                            return (
                                                <>
                                                    <p style={pStyle}>
                                                        Before instructing Sentinel Legal in relation to a motor
                                                        finance claim, please read the following.
                                                    </p>
                                                    <p style={pStyle}>
                                                        <strong>Free Routes Are Available</strong>
                                                    </p>
                                                    <p style={pStyle}>
                                                        You can complain directly to your lender at no cost, and
                                                        escalate to the Financial Ombudsman Service (FOS) free of
                                                        charge if you are not satisfied with the response.
                                                    </p>
                                                    <p style={pStyle}>
                                                        The Financial Conduct Authority (FCA) has also announced a
                                                        Motor Finance Redress Scheme, which eligible consumers will be
                                                        able to use to obtain compensation without instructing a
                                                        solicitor and without paying any fees.
                                                    </p>
                                                    <p style={pStyle}>
                                                        You do not need to instruct Sentinel Legal, or any solicitor or
                                                        claims management company, to access these free routes.
                                                    </p>
                                                    <p style={pStyle}>
                                                        <strong>Why Some Clients Still Choose Litigation</strong>
                                                    </p>
                                                    <p style={pStyle}>
                                                        In our view, based on cases the firm has seen and outcomes
                                                        recorded in litigation to date, the compensation produced by
                                                        the FCA's proposed redress methodology may be materially lower
                                                        than awards available through the courts. The FCA's proposals
                                                        also remain subject to consultation and challenge, and the
                                                        position may change before the scheme is finalised.
                                                    </p>
                                                    <p style={pStyle}>
                                                        Litigation carries different risks, timescales and costs to the
                                                        FCA scheme, and the firm will explain those in full before you
                                                        instruct us. Past outcomes are not a guarantee of future
                                                        results.
                                                    </p>
                                                    <p style={pStyle}>
                                                        <strong>Your Choice</strong>
                                                    </p>
                                                    <p style={pStyle}>You may:</p>
                                                    <ul style={{ paddingLeft: '20px', margin: '0 0 0.8em' }}>
                                                        <li style={liStyle}>
                                                            Use the FCA Motor Finance Redress Scheme at no cost.
                                                        </li>
                                                        <li style={liStyle}>
                                                            Complain to your lender directly at no cost.
                                                        </li>
                                                        <li style={liStyle}>
                                                            Refer your complaint to the Financial Ombudsman Service at
                                                            no cost.
                                                        </li>
                                                        <li style={liStyle}>
                                                            Instruct Sentinel Legal on a no win, no fee basis.
                                                        </li>
                                                    </ul>
                                                    <p style={pStyle}>
                                                        If you instruct Sentinel Legal, you will receive a client care
                                                        letter setting out our fees, your cancellation rights, and the
                                                        alternative routes above before you sign any retainer.
                                                    </p>
                                                </>
                                            )
                                        })(),
                                    }}
                                />
                                <div className={styles.previewDocumentsContainer}>
                                    <h3>Preview your documents</h3>
                                    <div className={styles.buttonContainer}>
                                        <button onClick={handleCfaModal} className={styles.actionButton}>
                                            Preview your CFA document
                                        </button>
                                        <button onClick={handleLoaModal} className={styles.actionButton}>
                                            Preview your LOA document
                                        </button>
                                        <button onClick={handleAofModal} className={styles.actionButton}>
                                            Preview your AOF document
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <Modal modalState={cfaModalState} previewModalAction={handleCfaModal}>
                                <Previewer url={currentClaim.cfa_doc_url} />
                            </Modal>
                            <Modal modalState={loaModalState} previewModalAction={handleLoaModal}>
                                <Previewer url={currentClaim.loa_doc_url} />
                            </Modal>
                            <Modal modalState={aofModalState} previewModalAction={handleAofModal}>
                                <Previewer url={currentClaim.aof_doc_url} />
                            </Modal>
                        </>
                    ) : (
                        <></>
                    )}
                </PocView>
            </Wrapper>
        </div>
    )
}
